$(document).ready(function() {
    $(".element-icon-stack .icon-container").click(function() {
        var href = $(this).attr('data-link');
        var openInNewWindow = $(this).attr('data-new-window');

        if (href) {
            if (openInNewWindow) {
                window.open(href);
            } else {
                window.location = href;
            }
        }

        return false;
    });
});